import { HIGHLIGHT_FIELD_TITLE, LINK_FIELD_TITLE } from '@anm/constants/embed';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { HIGHLIGHT_INDEX, PopoverTypeIndexes } from '..';
import { hostedVideoSelectors } from '../../../../../../../store/modules/hostedVideo';
import { getDefaultTextValue } from '../helpers';

export const useTextField = (activePopoverType: PopoverTypeIndexes) => {
  const popover = useSelector(hostedVideoSelectors.selectPopoverEmbed);

  const [textFieldValue, setTextFieldValue] = useState(popover?.text);

  const textFieldDefaultValue = getDefaultTextValue(
    activePopoverType,
    textFieldValue
  );

  const isHighLight = activePopoverType === HIGHLIGHT_INDEX;

  const textFieldTitle = isHighLight ? HIGHLIGHT_FIELD_TITLE : LINK_FIELD_TITLE;

  useEffect(() => {
    if (popover?.text === textFieldValue) return;

    setTextFieldValue(popover?.text);
  }, [popover?.text]);

  return [
    textFieldTitle,
    textFieldDefaultValue,
    textFieldValue,
    setTextFieldValue
  ] as const;
};
